module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('cIndex'), _vm._v(" "), _c('div', {
    staticClass: "successfulpayment"
  }, [_c('h3', [_vm._v("支付成功")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/duihao.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("支付成功！")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', [_vm._v("2s后跳转到 ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/startTest"
    }
  }, [_vm._v("脑检测页面")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98615148","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cardSucc.vue
// module id = 768
// module chunks = 1